/** Get JSON from localStorage if a key is provided and the value is valid JSON */
export const localStorageToJSON = (localStorageKey?: string) => {
  if (!localStorageKey) {
    return;
  }
  const stringValue = localStorage.getItem(localStorageKey);
  if (!stringValue) {
    return;
  }
  try {
    return JSON.parse(stringValue);
  } catch (error) {
    console.error(error);
  }
};
